import { gql } from '@apollo/client';

import assetFields from '../fragments/assetFields';
import listingFields from '../fragments/listingFields';

const assetCollectionActiveListSortByQuery = gql`
  ${assetFields}
  ${listingFields}
  query GetAssets(
    $nftContractAddress: String!
    $skip: Int
    $first: Int
    $excludedAssetsIds: [String] = [""]
  ) {
    assets(
      skip: $skip
      first: $first
      where: {
        tokenAddress: $nftContractAddress
        id_not_in: $excludedAssetsIds
      }
      orderBy: mogulPrice
      orderDirection: asc
    ) {
      ...AssetField
      activeListings {
        ...ListingField
      }
    }
  }
`;

export default assetCollectionActiveListSortByQuery;
